export const environment = {
    production: false,
    apiUrl: 'https://test-loyalty.qg.kz',
}
